import { atom } from 'recoil';

export type TrainingFileTeamOpenTableAtom = number[];

export const trainingFileTeamOpenTableAtom =
	atom<TrainingFileTeamOpenTableAtom>({
		key: 'trainingFileTeamOpenTable',
		default: [],
	});
